import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, TransitionGroup as _TransitionGroup, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/icons/landscape/LifecycleManagementLogo.svg'
import _imports_1 from '../../public/icons/santahat.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-59c4502f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_2 = {
  key: 1,
  style: {"padding":"16px 24px"}
}
const _hoisted_3 = {
  key: 0,
  style: {"display":"inline-flex","align-items":"flex-end"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["onClick", "title"]
const _hoisted_7 = {
  key: 0,
  style: {"width":"0px","height":"0px","position":"absolute","margin-top":"-200px","margin-left":"-200px","overflow":"visible"}
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  src: _imports_1,
  style: {"z-index":"1","position":"absolute","margin-top":"-30px","margin-left":"-70px"}
}
const _hoisted_10 = { class: "tenant-block-content-box" }
const _hoisted_11 = { class: "tenant-block-text" }
const _hoisted_12 = { style: {"z-index":"1"} }
const _hoisted_13 = {
  style: {"z-index":"1","font-size":"14px","line-height":"17px","color":"var(--accent-color5)","font-weight":"400"},
  class: "env"
}
const _hoisted_14 = { class: "tenant-block-icon" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tenant-block-content-box" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"z-index":"1"} }, "Sign Out")
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tenant-block-content-box" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"z-index":"1"} }, "Sign in as a different user")
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_20 = { class: "panelButtons" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_icon = _resolveComponent("f-icon")!
  const _component_TitleBar = _resolveComponent("TitleBar")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Empty = _resolveComponent("Empty")!
  const _component_CommonButton = _resolveComponent("CommonButton")!
  const _component_CloudIcon = _resolveComponent("CloudIcon")!
  const _component_RightPanel = _resolveComponent("RightPanel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_TitleBar, {
        title: _ctx.Localizer.Localize('ChooseTenant_Choose_Tenant')+' ('+_ctx.UserName+')'
      }, {
        "right-group": _withCtx(() => [
          (_ctx.TenantsNotFiltered!=null && _ctx.TenantsNotFiltered.length>5)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event)),
                style: {"max-width":"400px","float":"right"},
                placeholder: "Filter"
              }, null, 512)), [
                [_vModelText, _ctx.filter]
              ])
            : _createCommentVNode("", true),
          (_ctx.UserCanManageALM && _ctx.isLandscapeManagementFeatureFlagEnabled)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleAlmView && _ctx.toggleAlmView(...args))),
                tabindex: "0",
                role: "button",
                class: "toggle-alm-btn"
              }, [
                _hoisted_1,
                _createElementVNode("span", null, _toDisplayString(_ctx.Localizer.Localize("ModuleSecurityDetailsView_LandscapeManagement")), 1),
                _createVNode(_component_f_icon, {
                  icon: "chevronright",
                  size: 22,
                  color: "primary"
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.displaySpinner)
          ? (_openBlock(), _createBlock(_component_spinner, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (!_ctx.hideFilterTenants)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                    _createVNode(_component_Checkbox, {
                      modelValue: _ctx.filterTenants,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterTenants) = $event))
                    }, null, 8, ["modelValue"]),
                    _createTextVNode("   " + _toDisplayString(_ctx.Localizer.FormatLocalize("ChooseTenant_Display_only_0_tenants", _ctx.currentEnvironment)), 1)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_4,
              (_ctx.UserDoesNotHaveTenants)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_Empty, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Localizer.Localize("ChooseTenant_You_don_t_have_access_to_any_tenants")) + " (" + _toDisplayString(_ctx.UserName) + ").", 1)
                      ]),
                      _: 1
                    }),
                    (_ctx.showSignInSignOut)
                      ? (_openBlock(), _createBlock(_component_CommonButton, {
                          key: 0,
                          type: _ctx.ButtonType.Primary,
                          text: _ctx.Localizer.Localize('ChooseTenant_LOGOUT'),
                          onClick: _ctx.Logout_Click
                        }, null, 8, ["type", "text", "onClick"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_TransitionGroup, {
                name: "fso",
                tag: "div",
                class: "tenant-grid_v2"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Tenants, (Tenant, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "tenant_btn_v2",
                      onClick: ($event: any) => (_ctx.Tenant_Click(Tenant, $event)),
                      key: Tenant.name,
                      title: Tenant.name,
                      style: _normalizeStyle({'--i':i/_ctx.Tenants.length})
                    }, [
                      (_ctx.GetImage(Tenant.name)!=null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("img", {
                              src: _ctx.GetImage(Tenant.name),
                              style: {"width":"200px","height":"200px"}
                            }, null, 8, _hoisted_8)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isChristmas)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.FormatTenantName(Tenant.name, Tenant.caption)), 1),
                          _createElementVNode("span", _hoisted_13, " (" + _toDisplayString(Tenant.environment) + ") ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_CloudIcon, {
                            color: Tenant.bgColor ? Tenant.bgColor : 'var(--anaplan-background)'
                          }, null, 8, ["color"])
                        ])
                      ])
                    ], 12, _hoisted_6))
                  }), 128)),
                  (_ctx.showSignInSignOut)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (!_ctx.LoadingTenants)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "tenant_btn_v2",
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.Logout_Click && _ctx.Logout_Click(...args)))
                            }, _hoisted_16))
                          : _createCommentVNode("", true),
                        (!_ctx.LoadingTenants)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "tenant_btn_v2",
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.SwitchUser_Click && _ctx.SwitchUser_Click(...args)))
                            }, _hoisted_18))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (_ctx.GenerateAiImageRightPanel)
                ? (_openBlock(), _createBlock(_component_RightPanel, {
                    key: 2,
                    onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.GenerateAiImageRightPanel=false))
                  }, {
                    header: _withCtx(() => [
                      _hoisted_19
                    ]),
                    footer: _withCtx(() => [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_CommonButton, {
                          type: _ctx.ButtonType.Default,
                          text: _ctx.Localizer.Localize('Cancel_PascalCase'),
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.GenerateAiImageRightPanel=false))
                        }, null, 8, ["type", "text"])
                      ]),
                      _hoisted_21
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
      ]),
      _: 1
    })
  ]))
}